import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import LogoUpload from "./LogoUpload";

const InstitutionFormFields = ({
  data,
  errors,
  countries,
  selectedCountry,
  onFieldChange,
  onCountryChange,
  onFileChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="kt-form kt-form--label-right">
      <div className="kt-form__body">
        <div className="kt-section kt-section--first">
          <div className="kt-section__body">
            {/* Logo Upload */}
            <LogoUpload
              logoUrl={data.logo}
              onFileChange={onFileChange}
              errors={errors.logo}
            />

            {/* Name Field */}
            <div
              className={
                errors.name.length
                  ? "form-group row validated"
                  : "form-group row"
              }
            >
              <label
                className="col-xl-3 col-lg-3 col-form-label"
                htmlFor="name"
              >
                {t("Nom")} <span style={{ color: "red" }}>*</span>
              </label>
              <div className="col-lg-9 col-xl-6">
                <input
                  id="name"
                  type="text"
                  className={
                    errors.name.length
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder={t("Veuillez entrer le nom")}
                  value={data.name}
                  onChange={(e) => onFieldChange("name", e.target.value)}
                />
                {errors.name.length > 0 && (
                  <div className="invalid-feedback">
                    {errors.name.map((error, index) => (
                      <div key={index}>{error}</div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Acronyme Field */}
            <div
              className={
                errors.acronyme.length
                  ? "form-group row validated"
                  : "form-group row"
              }
            >
              <label
                className="col-xl-3 col-lg-3 col-form-label"
                htmlFor="acronyme"
              >
                {t("Acronyme")} <span style={{ color: "red" }}>*</span>
              </label>
              <div className="col-lg-9 col-xl-6">
                <input
                  id="acronyme"
                  type="text"
                  className={
                    errors.acronyme.length
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder={t("Veuillez entrer l'acronyme")}
                  value={data.acronyme}
                  onChange={(e) => onFieldChange("acronyme", e.target.value)}
                />
                {errors.acronyme.length > 0 && (
                  <div className="invalid-feedback">
                    {errors.acronyme.map((error, index) => (
                      <div key={index}>{error}</div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* ISO Code Field */}
            <div
              className={
                errors.iso_code.length
                  ? "form-group row validated"
                  : "form-group row"
              }
            >
              <label
                className="col-xl-3 col-lg-3 col-form-label"
                htmlFor="iso_code"
              >
                {t("Code Iso")} <span style={{ color: "red" }}>*</span>
              </label>
              <div className="col-lg-9 col-xl-6">
                <input
                  id="iso_code"
                  type="text"
                  className={
                    errors.iso_code.length
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder={t("Veuillez entrer le code ISO")}
                  value={data.iso_code}
                  onChange={(e) => onFieldChange("iso_code", e.target.value)}
                />
                {errors.iso_code.length > 0 && (
                  <div className="invalid-feedback">
                    {errors.iso_code.map((error, index) => (
                      <div key={index}>{error}</div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Country Select Field */}
            <div
              className={
                errors.country_id.length
                  ? "form-group row validated"
                  : "form-group row"
              }
            >
              <label
                className="col-xl-3 col-lg-3 col-form-label"
                htmlFor="country"
              >
                {t("Pays")} <span style={{ color: "red" }}>*</span>
              </label>
              <div className="col-lg-9 col-xl-6">
                <Select
                  id="country"
                  placeholder={t("Veuillez sélectionner le pays")}
                  value={selectedCountry}
                  isClearable={true}
                  onChange={onCountryChange}
                  options={countries}
                  className={errors.country_id.length ? "is-invalid" : ""}
                />
                {errors.country_id.length > 0 && (
                  <div className="invalid-feedback d-block">
                    {errors.country_id.map((error, index) => (
                      <div key={index}>{error}</div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstitutionFormFields;
